import { render, staticRenderFns } from "./VideoTranskript.vue?vue&type=template&id=0962ce10"
import script from "./VideoTranskript.vue?vue&type=script&lang=js"
export * from "./VideoTranskript.vue?vue&type=script&lang=js"
import style0 from "./VideoTranskript.vue?vue&type=style&index=0&id=0962ce10&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports